import Animated, {
  useAnimatedStyle,
  SharedValue,
} from "react-native-reanimated";
import { Platform, StyleSheet } from "react-native";
import {
  useAnimatedPageIndicatorItemStyle,
  useScaleFactor,
  useTheme,
  AHIcon,
} from "arkh";

import React from "react";

export function LastItemComponent({
  index,
  page,
}: {
  index: number;
  page: SharedValue<number>;
}) {
  const theme = useTheme();
  const style = useAnimatedPageIndicatorItemStyle({
    direction: "vertical",
    index,
    size: 12,
  });
  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: page.value === index ? 1 : 0.3,
    };
  });
  const sf = useScaleFactor();
  return (
    <Animated.View
      style={[
        {
          backgroundColor: theme.primary,
          paddingLeft:
            Platform.OS === "ios"
              ? StyleSheet.hairlineWidth
              : -StyleSheet.hairlineWidth,
          paddingTop: Platform.OS === "ios" ? StyleSheet.hairlineWidth : 0,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        },
        style,
        animatedStyle,
      ]}
    >
      <AHIcon type="add" customColor={theme.surface} forceSize={Math.ceil(8 * sf)} />
    </Animated.View>
  );
}
